import { KeyValue } from '@angular/common';
import { AggregationResult } from '../model/everything-search-result';
import { multiComparator } from './multi-comparator';

export function toKeyValueCount(
  aggregationResults: AggregationResult[],
  valueMapper: (key: string) => string = key => key
): KeyValueCount[] {
  return aggregationResults
      ?.map(({ total, value }) => ({ key: value, value: valueMapper(value), count: total }))
      ?.sort(multiComparator([ [ 'count', false ], [ 'value', true ] ]))
    ?? [];
}

export interface KeyValueCount extends KeyValue<string, string> {
  count?: number;
}
